import { instance } from './index';
import {
  IVanCancelErrorResponse,
  IVanCancelRequest,
  IVanCancelResponse,
} from '@dataTypes/vanCancelTypes';

export const vanCancel = async (
  data: IVanCancelRequest,
): Promise<IVanCancelResponse | IVanCancelErrorResponse> => {
  if (!data.kisTotalSalesId || !data.vanKey) {
    throw new Error('kisTotalSalesId or vanKey is undefined');
  }

  const response = await instance.post(`/user/transaction/van-cancel`, data);
  return response.data;
};

export const vanCancelStatus = async (kisTotalSalesId: number | undefined): Promise<boolean> => {
  if (!kisTotalSalesId) {
    throw new Error('kisTotalSalesId is undefined');
  }

  const response = await instance.get(`/user/transaction/${kisTotalSalesId}/van-cancel-status`);
  return response.data;
};
